class DatePicker extends HTMLElement {
  constructor() {
    super();

    // Create a shadow root
    const shadow = this.attachShadow({ mode: "open" });

    // Create a custom div element to display the date and calendar icon
    const container = document.createElement("div");
    container.classList.add("container");

    const checkbox = document.createElement("input");
    checkbox.type = "checkbox";
    checkbox.id = "rush-charge";
    checkbox.classList.add("checkbox-input");

    const label = document.createElement("label");
    label.innerText = `${rushText}`;
    label.htmlFor = "rush-charge";
    label.classList.add("checkbox-label");

    const rushCharge = document.createElement("div");
    // rushCharge.appendChild(checkbox);
    // rushCharge.appendChild(label);
    rushCharge.classList.add("rush-rate");

    const containerWrapper = document.createElement("div");
    containerWrapper.appendChild(container);
    containerWrapper.append(rushCharge);
    containerWrapper.classList.add("container-wrapper");

    const dateDisplay = document.createElement("div");
    dateDisplay.classList.add("date-display");
    // document.querySelector("#lead-time").innerHTML = `<strong>Lead Time</strong>: ${leadTime} days`;

    // Set the minimum date to today's date plus x days
    const minDate = new Date();
    fetch("/cart.js")
      .then((response) => response.json())
      .then((data) => {
        dateDisplay.innerHTML = "Optional: Choose an In-Hand Date.";
        checkbox.checked = data.items.some((item) => item.id == "45039241593147") ? true : false;
        if (checkbox.checked) {
          document.querySelector("#lead-time").innerHTML = `<strong>Lead Time</strong>: ${1} days`;
          let numDays = 1;
          let today = new Date();
          let minDate = new Date(today.getTime() + numDays * 24 * 60 * 60 * 1000);
          $("#datepicker").datepicker({
            changeYear: true,
            changeMonth: true,
            dateFormat: "mm/dd/yy",
            maxDate: "+2Y",
            minDate: minDate,
            // beforeShowDay: function (date) {
            //   let selectableDate = new Date(today.getTime() + numDays * 24 * 60 * 60 * 1000);

            //   // Add public holidays as non-selectable dates
            //   let isPublicHoliday = publicHolidays.some(function (holiday) {
            //     // console.log(holiday.trim(), date.toLocaleDateString())
            //     return date.toLocaleDateString().trim() === holiday.trim();
            //   });

            //   let isSelectable =
            //     date.getTime() >= selectableDate.getTime() &&
            //     date.getDay() !== 0 &&
            //     date.getDay() !== 6 &&
            //     date.getDay() !== 5 &&
            //     !isPublicHoliday; // 0 is Sunday, 6 is Saturday
            //   return [isSelectable, ""];
            // },
          });
        } else {
          let numDays = 1;
          let today = new Date();
          let minDate = new Date(today.getTime() + numDays * 24 * 60 * 60 * 1000);
          $("#datepicker").datepicker({
            changeYear: true,
            changeMonth: true,
            dateFormat: "mm/dd/yy",
            maxDate: "+2Y",
            minDate: minDate,
            // beforeShowDay: function (date) {
            //   let selectableDate = new Date(today.getTime() + numDays * 24 * 60 * 60 * 1000);

            //   // Add public holidays as non-selectable dates
            //   let isPublicHoliday = publicHolidays.some(function (holiday) {
            //     return date.toLocaleDateString().trim() === holiday.trim();
            //   });

            //   let isSelectable =
            //     date.getTime() >= selectableDate.getTime() &&
            //     date.getDay() !== 0 &&
            //     date.getDay() !== 6 &&
            //     date.getDay() !== 5 &&
            //     !isPublicHoliday; // 0 is Sunday, 6 is Saturday
            //   return [isSelectable, ""];
            // },
          });
        }
      });

    const calendarIcon = document.createElement("span");
    calendarIcon.innerHTML = `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-calendar">
          <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
          <line x1="16" y1="2" x2="16" y2="6"></line>
          <line x1="8" y1="2" x2="8" y2="6"></line>
          <line x1="3" y1="10" x2="21" y2="10"></line>
        </svg>
      `;
    calendarIcon.setAttribute("aria-hidden", "true");

    container.appendChild(dateDisplay);
    container.appendChild(calendarIcon);

    // Append the input and custom div to the shadow root
    shadow.appendChild(containerWrapper);

    // Define the element's styles
    const styles = `
        :host {
          display: block;
          margin-bottom: 1rem;
        }

        .container {
            display: flex;
            justify-content: space-between;
            border: 1px solid;
            /* align-items: center; */
            padding: 0 1rem;
            padding-top: 1rem;
            cursor: pointer;
        }

        date-picker .date-display {
          padding-right: 2rem;
        }

        date-picker .fa-calendar {
          position: absolute;
          top: 50%;
          right: 0.5rem;
          transform: translateY(-50%);
          font-size: 1.2rem;
          color: #ccc;
          cursor: pointer;
        }

        date-picker .fa-calendar:hover {
          color: #555;
        }

        date-picker input[type="date"] {
          display: block;
          width: 100%;
          padding: 0.5rem;
          border: 1px solid #ccc;
          border-radius: 4px;
          box-sizing: border-box;
          z-index: 1;
          visibility: hidden;
        }

        date-picker input[type="date"]:focus + .container .fa-calendar {
          color: #555;
        }

        date-picker input[type="date"]::-webkit-calendar-picker-indicator {
          display: none; /* Hide the default calendar icon */
        }

        svg{
            width: 28px;
        }

        .container-wrapper{
          min-width: 100%;
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
        }

        .rush-rate{
          text-align: initial;
          cursor: pointer;
        }

        .checkbox-input {
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
          height: 20px;
          width: 20px;
          border: 2px solid #ddd;
          margin-right: 10px;
          vertical-align: middle;
          cursor: pointer;
        }

        .checkbox-input:checked {
          background-color: #772483;
        }

        .checkbox-label {
          font-size: 16px;
        }

        .rush-rate {
          margin: 10px 0;
          margin-bottom: 0;
        }

        .checkbox-label:hover {
          color: #772483;
        }
      `;

    // Create a style element and set its text content to the styles
    const style = document.createElement("style");
    style.textContent = styles;

    // Append the style to the shadow root
    shadow.appendChild(style);

    // Add a click event listener to the calendar icon to trigger the input's click event
    container.addEventListener("click", () => {
      $("#datepicker").datepicker("show");
    });

    $("#datepicker").on(
      "change",
      debounce(() => {
        const selectedDate = $("#datepicker").datepicker("getDate").toDateString();
        const body = JSON.stringify({
          attributes: {
            deliveryDate: selectedDate,
          },
        });
        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
        this.updateDisplay(selectedDate);
      }, 100)
    );

    checkbox.addEventListener("change", () => {
      // Check if the rush charge checkbox is checked
      if (checkbox.checked) {
        // Add the rush charge item to the cart
        const item = { id: "45039241593147", quantity: 1, attributes: { deliveryDate: "" } };
        const url = "/cart/add.js";
        const options = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(item),
        };
        fetch(url, options)
          .then((response) => response.json())
          .then((data) => {
            // Update the cart total
            this.updateCartTotal();
          })
          .catch((error) => console.error(error));
      } else {
        // Remove the rush charge item from the cart
        let rushChargeItem;
        fetch("/cart.js")
          .then((response) => response.json())
          .then((data) => {
            let items = data.items;
            rushChargeItem = items.find((item) => item.id == "45039241593147");
            console.log(rushChargeItem);
            if (rushChargeItem) {
              const key = rushChargeItem.key;
              const url = "/cart/change.js";
              const options = {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify({ id: key, quantity: 0, attributes: { deliveryDate: "" } }),
              };
              fetch(url, options)
                .then((response) => response.json())
                .then((data) => {
                  // Update the cart total
                  this.updateCartTotal();
                })
                .catch((error) => console.error(error));
            }
          });
      }
    });
  }

  // Update the date display when the input value changes
  updateDisplay(selectedDate) {
    const dateDisplay = this.shadowRoot.querySelector(".date-display");
    dateDisplay.textContent = `${selectedDate}`;
  }

  updateCartTotal() {
    location.reload();
  }
}

// Define the custom element
customElements.define("date-picker", DatePicker);

$("#cart").submit(async function (event) {
  let selectedDate = $("#datepicker").datepicker("getDate");
  if (!selectedDate) {
    event.preventDefault();
    let formData = {
      attributes: {
        deliveryDate: "",
      },
    };

    let response = await fetch(window.Shopify.routes.root + "cart/update.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    });

    let data = await response.json();
    window.location = "/checkout";
  }
});
